let isImported = false;

class RecaptchaHelper {
  static async importRecaptcha() {
    if (!isImported) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
      isImported = true;
    }
  }
}

export default RecaptchaHelper;
